var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["animate"]: () => (__WEBPACK_EXTERNAL_MODULE__static_vendor_min_js_13adf662__.animate), ["scroll"]: () => (__WEBPACK_EXTERNAL_MODULE__static_vendor_min_js_13adf662__.scroll) });